import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForContestEntryComponent extends Component {
  // Defaults
  availableFilters = [
    {
      key: 'status',
      type: 'selectValueLabel',
      options: [1, 2, 3, 4, 5],
    },
  ];
  defaultColumns = ['email', 'status', 'cmsCreated'];

  tableColumns = [
    {
      property: 'email',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'status',
      type: 'translate-value',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
